import Konva from "konva";
import {createContext, useContext} from "react";

export type SelectionRectangle = {
    visible: boolean;
    x1: number;
    y1: number;
    x2: number;
    y2: number;
}

export type SelectionRectangleContextReturn = {
    selectionRectangle: SelectionRectangle;
    setSelectionRectangle: (selectionRect: SelectionRectangle) => void;
    handleStartSelection: (event: Konva.KonvaEventObject<MouseEvent>) => void;
    handleMoveSelection: (event: Konva.KonvaEventObject<MouseEvent>) => void;
    handleEndSelection: () => void;
}

export const SelectionRectangleContext = createContext<SelectionRectangleContextReturn | null>(null);

export function useSelectionRectangle() {
    const context = useContext(SelectionRectangleContext);
    if (!context) {
        throw new Error("useSelectionRectangle must be used within a SelectionRectangleProvider");
    }
    return context;
}
